import { render } from "./GAReader.vue?vue&type=template&id=ad0dfde4"
import script from "./GAReader.vue?vue&type=script&lang=js"
export * from "./GAReader.vue?vue&type=script&lang=js"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__